import {SystemModuleUiResult, SystemModuleUiSettingsNavigation} from "app/Interface/ApiMapped/System/SystemModuleUi"
import {useEffect, useState} from "react"
import {Subscription} from "rxjs"
import {systemModuleQuery, systemModuleStore} from "store/system/module/system.module.store"
import {onEmit} from "utils/onEmit"

export const SubscribeModuleUiService = {
  active: 'active',
  editLayoutId: 'editLayout',
}

function SystemModuleUiService(subscribe: string[], caller: string) {

  const subscribed: Subscription[] = []

  const [activeSystemModuleUi, setActiveSystemModuleUi] = useState<SystemModuleUiResult>()

  useEffect(() => {
    if (!subscribe) throw Error(`ClientService: Define what you want to subscribe to`)
    if (!caller) throw Error("ClientService: Define where you are calling from")

    if (subscribe.includes(SubscribeModuleUiService.active))
      subActive()

    return () => {
      subscribed.map(s => s.unsubscribe())
    }
  }, [])

  function setSettingsNavigation(navigate: SystemModuleUiSettingsNavigation, moduleId?: string) {
    if (moduleId) {
      systemModuleStore.ui.update(moduleId, state => {
        state.settings = navigate
      })
    } else {
      systemModuleStore.ui.updateActive(state => {
        state.settings = navigate
      })
    }
  }

  function navigateSettings(navLink: string, moduleId?: string) {
    if (moduleId) {
      systemModuleStore.ui.update(moduleId, state => {
        if (!state.settings)
          state.settings = {
            navLink
          }
        else
          state.settings.navLink = navLink
      })
    } else {
      systemModuleStore.ui.updateActive(state => {
        if (!state.settings)
          state.settings = {
            navLink
          }
        state.settings.navLink = navLink
      })
    }
  }

  return {
    activeSystemModuleUi,
    setSettingsNavigation,
    navigateSettings,
  }

  function subActive() {
    subscribed.push(onEmit(systemModuleQuery.ui.selectActive(), newActive => {
      setActiveSystemModuleUi(newActive)
    }))
  }
}

export default SystemModuleUiService
